module.exports = __webpack_public_path__ + "img/up-right-arrow.7f666291.png";